module.exports = "https://r.zoocdn.com/_next/static/images/second-stepper-couple-a150f146a19fb817b0e7945eacd3219b.png";